import * as React from "react";
import type { Icon, IconProps, IconWeight } from "@phosphor-icons/react/dist/lib/types";
import { Archive } from "@phosphor-icons/react/dist/csr/Archive";
import { ArrowClockwise } from "@phosphor-icons/react/dist/csr/ArrowClockwise";
import { ArrowCounterClockwise } from "@phosphor-icons/react/dist/csr/ArrowCounterClockwise";
import { ArrowLeft } from "@phosphor-icons/react/dist/csr/ArrowLeft";
import { ArrowRight } from "@phosphor-icons/react/dist/csr/ArrowRight";
import { ArrowSquareOut } from "@phosphor-icons/react/dist/csr/ArrowSquareOut";
import { ArrowsOut } from "@phosphor-icons/react/dist/csr/ArrowsOut";
import { Barcode } from "@phosphor-icons/react/dist/csr/Barcode";
import { BellSimple } from "@phosphor-icons/react/dist/csr/BellSimple";
import { BellSimpleRinging } from "@phosphor-icons/react/dist/csr/BellSimpleRinging";
import { Buildings } from "@phosphor-icons/react/dist/csr/Buildings";
import { Calculator } from "@phosphor-icons/react/dist/csr/Calculator";
import { Calendar } from "@phosphor-icons/react/dist/csr/Calendar";
import { CalendarDots } from "@phosphor-icons/react/dist/csr/CalendarDots";
import { Camera } from "@phosphor-icons/react/dist/csr/Camera";
import { CaretDoubleUp } from "@phosphor-icons/react/dist/csr/CaretDoubleUp";
import { CaretDown } from "@phosphor-icons/react/dist/csr/CaretDown";
import { CaretRight } from "@phosphor-icons/react/dist/csr/CaretRight";
import { ChartBar } from "@phosphor-icons/react/dist/csr/ChartBar";
import { ChartLineUp } from "@phosphor-icons/react/dist/csr/ChartLineUp";
import { Check } from "@phosphor-icons/react/dist/csr/Check";
import { CheckCircle } from "@phosphor-icons/react/dist/csr/CheckCircle";
import { Clock } from "@phosphor-icons/react/dist/csr/Clock";
import { ClockCounterClockwise } from "@phosphor-icons/react/dist/csr/ClockCounterClockwise";
import { CloudArrowUp } from "@phosphor-icons/react/dist/csr/CloudArrowUp";
import { Copy } from "@phosphor-icons/react/dist/csr/Copy";
import { Crosshair } from "@phosphor-icons/react/dist/csr/Crosshair";
import { Cube } from "@phosphor-icons/react/dist/csr/Cube";
import { DeviceTablet } from "@phosphor-icons/react/dist/csr/DeviceTablet";
import { DotsThreeVertical } from "@phosphor-icons/react/dist/csr/DotsThreeVertical";
import { DownloadSimple } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { Envelope } from "@phosphor-icons/react/dist/csr/Envelope";
import { EnvelopeOpen } from "@phosphor-icons/react/dist/csr/EnvelopeOpen";
import { EnvelopeSimpleOpen } from "@phosphor-icons/react/dist/csr/EnvelopeSimpleOpen";
import { FileText } from "@phosphor-icons/react/dist/csr/FileText";
import { Fire } from "@phosphor-icons/react/dist/csr/Fire";
import { FloppyDisk } from "@phosphor-icons/react/dist/csr/FloppyDisk";
import { Funnel } from "@phosphor-icons/react/dist/csr/Funnel";
import { Gauge } from "@phosphor-icons/react/dist/csr/Gauge";
import { Gear } from "@phosphor-icons/react/dist/csr/Gear";
import { GearSix } from "@phosphor-icons/react/dist/csr/GearSix";
import { GridNine } from "@phosphor-icons/react/dist/csr/GridNine";
import { HardDrives } from "@phosphor-icons/react/dist/csr/HardDrives";
import { ImageSquare } from "@phosphor-icons/react/dist/csr/ImageSquare";
import { Info } from "@phosphor-icons/react/dist/csr/Info";
import { Kanban } from "@phosphor-icons/react/dist/csr/Kanban";
import { ListBullets } from "@phosphor-icons/react/dist/csr/ListBullets";
import { ListChecks } from "@phosphor-icons/react/dist/csr/ListChecks";
import { ListNumbers } from "@phosphor-icons/react/dist/csr/ListNumbers";
import { Lock } from "@phosphor-icons/react/dist/csr/Lock";
import { LockOpen } from "@phosphor-icons/react/dist/csr/LockOpen";
import { MagnifyingGlass } from "@phosphor-icons/react/dist/csr/MagnifyingGlass";
import { MagnifyingGlassMinus } from "@phosphor-icons/react/dist/csr/MagnifyingGlassMinus";
import { MagnifyingGlassPlus } from "@phosphor-icons/react/dist/csr/MagnifyingGlassPlus";
import { Monitor } from "@phosphor-icons/react/dist/csr/Monitor";
import { Moon } from "@phosphor-icons/react/dist/csr/Moon";
import { Package } from "@phosphor-icons/react/dist/csr/Package";
import { PencilSimple } from "@phosphor-icons/react/dist/csr/PencilSimple";
import { Plus } from "@phosphor-icons/react/dist/csr/Plus";
import { Printer } from "@phosphor-icons/react/dist/csr/Printer";
import { Prohibit } from "@phosphor-icons/react/dist/csr/Prohibit";
import { PushPin } from "@phosphor-icons/react/dist/csr/PushPin";
import { QrCode } from "@phosphor-icons/react/dist/csr/QrCode";
import { Question } from "@phosphor-icons/react/dist/csr/Question";
import { Scan } from "@phosphor-icons/react/dist/csr/Scan";
import { SealCheck } from "@phosphor-icons/react/dist/csr/SealCheck";
import { ShieldCheck } from "@phosphor-icons/react/dist/csr/ShieldCheck";
import { ShieldStar } from "@phosphor-icons/react/dist/csr/ShieldStar";
import { SignOut } from "@phosphor-icons/react/dist/csr/SignOut";
import { SlidersHorizontal } from "@phosphor-icons/react/dist/csr/SlidersHorizontal";
import { Sparkle } from "@phosphor-icons/react/dist/csr/Sparkle";
import { Stack } from "@phosphor-icons/react/dist/csr/Stack";
import { Star } from "@phosphor-icons/react/dist/csr/Star";
import { Sun } from "@phosphor-icons/react/dist/csr/Sun";
import { Table } from "@phosphor-icons/react/dist/csr/Table";
import { Trash } from "@phosphor-icons/react/dist/csr/Trash";
import { Tray } from "@phosphor-icons/react/dist/csr/Tray";
import { Truck } from "@phosphor-icons/react/dist/csr/Truck";
import { UploadSimple } from "@phosphor-icons/react/dist/csr/UploadSimple";
import { User } from "@phosphor-icons/react/dist/csr/User";
import { UserCirclePlus } from "@phosphor-icons/react/dist/csr/UserCirclePlus";
import { UserGear } from "@phosphor-icons/react/dist/csr/UserGear";
import { UserPlus } from "@phosphor-icons/react/dist/csr/UserPlus";
import { Users } from "@phosphor-icons/react/dist/csr/Users";
import { Video } from "@phosphor-icons/react/dist/csr/Video";
import { Warehouse } from "@phosphor-icons/react/dist/csr/Warehouse";
import { WarningCircle } from "@phosphor-icons/react/dist/csr/WarningCircle";
import { WarningOctagon } from "@phosphor-icons/react/dist/csr/WarningOctagon";
import { Wrench } from "@phosphor-icons/react/dist/csr/Wrench";
import { X } from "@phosphor-icons/react/dist/csr/X";

type AppIconProps = IconProps & {
  size?: number | string;
};

function createAppIcon(IconComponent: Icon, defaultWeight: IconWeight = "regular") {
  return React.forwardRef<SVGSVGElement, AppIconProps>(function AppIcon(
    { size = 18, weight = defaultWeight, style, ...props },
    ref,
  ) {
    return (
      <IconComponent
        ref={ref}
        data-app-icon="true"
        size={size}
        weight={weight}
        style={{ display: "block", flexShrink: 0, ...style }}
        {...props}
      />
    );
  });
}

export const Icons = {
  Add: createAppIcon(Plus, "bold"),
  Admin: createAppIcon(ShieldStar, "duotone"),
  Archive: createAppIcon(Archive),
  ArrowLeft: createAppIcon(ArrowLeft),
  ArrowRight: createAppIcon(ArrowRight),
  Asset: createAppIcon(Cube, "duotone"),
  BadgeCheck: createAppIcon(SealCheck, "duotone"),
  Ban: createAppIcon(Prohibit, "bold"),
  Bell: createAppIcon(BellSimple),
  BellRing: createAppIcon(BellSimpleRinging, "bold"),
  Boxes: createAppIcon(Stack, "duotone"),
  Building: createAppIcon(Buildings, "duotone"),
  Calculator: createAppIcon(Calculator),
  Calendar: createAppIcon(Calendar),
  CalendarDays: createAppIcon(CalendarDots),
  Camera: createAppIcon(Camera, "bold"),
  Chart: createAppIcon(ChartBar, "duotone"),
  ChartColumn: createAppIcon(ChartLineUp, "duotone"),
  Check: createAppIcon(Check, "bold"),
  CheckCircle: createAppIcon(CheckCircle, "duotone"),
  ChevronDown: createAppIcon(CaretDown),
  ChevronRight: createAppIcon(CaretRight),
  ChevronsUp: createAppIcon(CaretDoubleUp),
  CircleAlert: createAppIcon(WarningCircle, "duotone"),
  Clock: createAppIcon(Clock),
  Clock3: createAppIcon(Clock),
  ClipboardList: createAppIcon(ListChecks),
  Copy: createAppIcon(Copy, "bold"),
  Crosshair: createAppIcon(Crosshair),
  Delete: createAppIcon(Trash, "bold"),
  Download: createAppIcon(DownloadSimple, "bold"),
  Empty: createAppIcon(Tray, "duotone"),
  Equipment: createAppIcon(Package, "duotone"),
  ExternalLink: createAppIcon(ArrowSquareOut),
  FileText: createAppIcon(FileText),
  Filter: createAppIcon(Funnel),
  Flame: createAppIcon(Fire, "duotone"),
  Gauge: createAppIcon(Gauge, "duotone"),
  Grid: createAppIcon(GridNine),
  HardDrive: createAppIcon(HardDrives, "duotone"),
  Help: createAppIcon(Question),
  History: createAppIcon(ClockCounterClockwise),
  Image: createAppIcon(ImageSquare),
  Info: createAppIcon(Info),
  Inventory: createAppIcon(Stack, "duotone"),
  Kanban: createAppIcon(Kanban, "duotone"),
  ListChecks: createAppIcon(ListChecks),
  ListTodo: createAppIcon(ListBullets),
  Lock: createAppIcon(Lock),
  LockOpen: createAppIcon(LockOpen),
  LogOut: createAppIcon(SignOut, "bold"),
  Mail: createAppIcon(Envelope),
  MailOpen: createAppIcon(EnvelopeOpen),
  Mails: createAppIcon(EnvelopeSimpleOpen, "duotone"),
  Maximize: createAppIcon(ArrowsOut),
  Menu: createAppIcon(GridNine),
  Monitor: createAppIcon(Monitor),
  MonitorCog: createAppIcon(GearSix),
  Moon: createAppIcon(Moon),
  More: createAppIcon(DotsThreeVertical),
  Package: createAppIcon(Package, "duotone"),
  Panel: createAppIcon(GridNine),
  Pencil: createAppIcon(PencilSimple, "bold"),
  Pin: createAppIcon(PushPin),
  Printer: createAppIcon(Printer, "bold"),
  Qr: createAppIcon(QrCode),
  Refresh: createAppIcon(ArrowClockwise, "bold"),
  Save: createAppIcon(FloppyDisk, "bold"),
  Scan: createAppIcon(Scan),
  ScanBarcode: createAppIcon(Barcode),
  Search: createAppIcon(MagnifyingGlass),
  SearchX: createAppIcon(MagnifyingGlassMinus, "duotone"),
  Settings: createAppIcon(Gear),
  Shield: createAppIcon(ShieldCheck, "duotone"),
  Sliders: createAppIcon(SlidersHorizontal),
  Sparkles: createAppIcon(Sparkle, "duotone"),
  Star: createAppIcon(Star, "duotone"),
  StarOff: createAppIcon(Star),
  Sun: createAppIcon(Sun),
  Table: createAppIcon(Table),
  Tablet: createAppIcon(DeviceTablet, "duotone"),
  Tally: createAppIcon(ListNumbers),
  Tmc: createAppIcon(Calculator, "duotone"),
  TrendingUp: createAppIcon(ChartLineUp, "duotone"),
  TriangleAlert: createAppIcon(WarningOctagon, "duotone"),
  Truck: createAppIcon(Truck, "duotone"),
  Undo: createAppIcon(ArrowCounterClockwise, "bold"),
  Upload: createAppIcon(UploadSimple, "bold"),
  UploadCloud: createAppIcon(CloudArrowUp, "bold"),
  User: createAppIcon(User),
  UserAdd: createAppIcon(UserPlus, "bold"),
  UserCog: createAppIcon(UserGear, "duotone"),
  UserRoundAdd: createAppIcon(UserCirclePlus, "duotone"),
  Users: createAppIcon(Users, "duotone"),
  Video: createAppIcon(Video),
  Warehouse: createAppIcon(Warehouse, "duotone"),
  Wrench: createAppIcon(Wrench, "bold"),
  X: createAppIcon(X, "bold"),
  ZoomIn: createAppIcon(MagnifyingGlassPlus),
  ZoomOut: createAppIcon(MagnifyingGlassMinus),
} as const;

export type AppIconName = keyof typeof Icons;
